import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import CloseIcon from '@mui/icons-material/Close';
import Button from 'newComponents/Button';
import { CircularProgress } from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
import { useNotifyAlert } from 'context/NotifyAlert';

const PhoneCallModal = ( {
	phoneData,
	onClose
} ) => {
	const { handleGetPairingCodeToPhoneCall, handleDisconnectPhoneCall } = useMessage();
	const [ pairingCode, setPairingCode ] = useState( null );
	const [ isLoadingPairingCode, setIsLoadingPairingCode ] = useState( false );
	const { setShowNotify } = useNotifyAlert();

	const phoneCallIsActive = phoneData?.phoneCallIsActive;

	const handleRequestPairingCode = async () => {
		if ( !phoneData?.id ) return;
		setIsLoadingPairingCode( true );
		try {
			const code = await handleGetPairingCodeToPhoneCall( phoneData.id );
			setPairingCode( code );
		} catch ( error ) {
			console.error( 'Failed to get pairing code:', error );
			setShowNotify( {
				status : 'error',
				text   : error?.response?.data?.message || 'Erro ao obter código de pareamento do whatsapp'
			} );
		} finally {
			setIsLoadingPairingCode( false );
		}
	};
	
	const handleConfirmDisconnect = async () => {
		if ( !phoneData?.id ) return;
		try {
			await handleDisconnectPhoneCall( phoneData.id );
			onClose();
		} catch ( error ) {
			console.error( 'Failed to disconnect phone call:', error );
			setShowNotify( {
				status : 'error',
				text   : error?.response?.data?.message || 'Erro ao desconectar chamada telefônica'
			} );
		}
	};

	if ( phoneCallIsActive ) {
		return (
			<S.ModalContainer>
				<S.CloseButton onClick={onClose}>
					<CloseIcon />
				</S.CloseButton>
				<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
					<S.MessageContent>
						Deseja desativar a função de ligar no número selecionado?
					</S.MessageContent>
					<S.ButtonsContainer>
						<Button type="button" onClick={onClose}>
							Cancelar
						</Button>
						<Button type="button" onClick={handleConfirmDisconnect}>
							Confirmar
						</Button>
					</S.ButtonsContainer>
				</div>
			</S.ModalContainer>
		);
	}

	return (
		<S.ModalContainer>
			<S.CloseButton onClick={onClose}>
				<CloseIcon />
			</S.CloseButton>
			<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
				<S.MessageContent>
					Dentro do aplicativo do whatsapp, na mesma aba onde é feita a leitura do qr-code, você deve clicar em &quot;Conectar com número de telefone&quot; e inserir o seguinte código:
				</S.MessageContent>
				{isLoadingPairingCode ? (
					<S.LoadingContainer>
						<CircularProgress />
					</S.LoadingContainer>
				) : pairingCode ? (
					<>
						<S.PairingCodeBox>{pairingCode}</S.PairingCodeBox>
						<Button type="button" onClick={handleRequestPairingCode}>
							<RefreshIcon /> Solicitar um novo código de pareamento
						</Button>
					</>
				) : (
					<Button type="button" onClick={handleRequestPairingCode} disabled={isLoadingPairingCode}>
						Solicitar código de pareamento
					</Button>
				)}
			</div>
		</S.ModalContainer>
	);
};

PhoneCallModal.propTypes = {
	phoneData                      : PropTypes.object,
	onClose                        : PropTypes.func.isRequired
};

export default PhoneCallModal;
